import { CloseIcon } from "@/components/ui/icon";   
import { cn } from "@/utils/cn";
import { ComponentPropsWithoutRef, forwardRef } from "react";

interface CloseButtonProps extends ComponentPropsWithoutRef<"button"> {
  className?: string;
}

const CloseButton = forwardRef<HTMLButtonElement, CloseButtonProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          "group flex items-center justify-center w-10 h-10 bg-white rounded-sm hover:bg-white/80",
          className
        )}
        tabIndex={-1}
        {...props}
      >
        <CloseIcon className="w-5 h-5" />
      </button>
    );
  }
);

CloseButton.displayName = "CloseButton";

export default CloseButton;
